const KeenSlider = window.KeenSlider

const { breakpoints } = window.BAO.MediaBreakpoints
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins
const { getElement } = window.BAO.Utils

class PushCartRecommendations extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.setupCarousel()

    const cartCount = Number(
      getElement('[data-push-cart-el="footer"]')?.dataset.cartCount,
    )
    this.updateDisplay(cartCount)

    this.handleCartChanged = this.handleCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.handleCartChanged,
    )
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.handleCartChanged,
    )
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.7,
          spacing: 1,
        },
        breakpoints: {
          [`(min-width: ${breakpoints.xs}px)`]: {
            slides: {
              perView: 2.2,
              spacing: 1,
            },
          },
          [`(min-width: ${breakpoints.sm}px)`]: {
            disabled: true,
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  updateDisplay (cartCount) {
    this.externalEls.mobile?.element.classList.toggle(
      'psh-Cart_Recommendations-active',
      cartCount,
    )

    this.externalEls.desktop?.element.classList.toggle(
      'drw-Drawer_Sidebar-active',
      cartCount,
    )
    this.externalEls.desktop?.element.setAttribute('aria-expanded', cartCount)
  }

  /**
   * @param {CustomEvent} event
   */
  handleCartChanged (event) {
    const { state } = event.detail
    if (!state) return
    if (!state.sections) return

    if (!('push-cart-count' in state.sections)) return

    const newCartCount = Number(
      this.getCount(state.sections['push-cart-count']),
    )

    this.updateDisplay(newCartCount)
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = window.BAO.sectionRenderer.convertToDOM(html)
    return DOM.querySelector('#push-cart-count').textContent
  }
}

if (!customElements.get('push-cart-recommendations')) {
  customElements.define('push-cart-recommendations', PushCartRecommendations)
}
